import {makeStyles} from '@material-ui/core';

export const useStyles = makeStyles(theme => {
  return {
    outerContainer: {
      paddingTop: '1rem',
      paddingLeft: '1rem',
      paddingRight: '1rem',
      paddingBottom: '3.5rem',
    },
    breadcrumbItem: {
      display: 'flex',
      alignItems: 'center',
      textDecoration: 'none',
      color: theme.palette.text.primary,
      padding: '4px 0px',
    },
    activeBreadcrumbItem: {
      color: theme.palette.primary.main,
    },
    breadcrumpIcon: {
      marginRight: '5px',
      fontSize: '18px',
    },
    breadcrumpLabel: {
      fontSize: '14px',
    },


    addOragnizationContainer: {
      marginTop: '8px',
      marginBottom: '4rem',
    },
    addOragnizationLabelContainer: {
      marginBottom: '10px',
    },
    addOragnizationLabel: {
      fontSize: '1.6rem',
    },
    addOragnizationFormContainer: {
      marginTop: '20px',
    },
    addOragnizationFormInnerContainer: {
      padding: '16px',
    },


    footerContainer: {
      zIndex: '1000',
      position: 'fixed',
      bottom: '0',
      width: '100%',
      left: '0',
    },
    footerContainerInner: {
      height: '60px',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      paddingRight: '1.5rem',
    },
    saveButton: {
      marginLeft: '1rem',
    },
  }
});
